<template>
  <div class="ccui-app-box-iframe-operate-container">
    <breadcrumbSourcing :breadcrumb-data="breadcrumbData"></breadcrumbSourcing>
    <div class="ccui-app-iframe-container-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <!-- <div v-if="relationWarningList.length > 0" class="tips">
          <div style="color: red">温馨提示：</div>
          <div v-for="(item, index) in relationWarningList" :key="index">
            {{ item }}
          </div>
        </div> -->
        <div class="ccui-tab-iframe">
          <div class="ccui-tab-wrapper">
            <el-button
              :type="tableTop == 1 ? 'table-top-active' : 'table-top'"
              size="mini"
              @click="tableTop = 1"
              >{{
                `${skillAndCommonTemp ? "技术商务评分" : "商务评分"}${
                  subPackageFlag == "0" ? "" : "(包件：" + packName + ")"
                }`
              }}</el-button
            >
            <!-- <el-button
              :type="tableTop == 2 ? 'table-top-active' : 'table-top'"
              size="mini"
              @click="tableTop = 2"
              >供应商信用信息</el-button
            > -->
          </div>
        </div>
        <caigoufengxian
          v-if="tableTop == 2"
          :schemeId="schemeId"
        ></caigoufengxian>

        <el-table
          v-if="tableTop == 1"
          :data="transposedData"
          ref="table"
          max-height="510"
          :span-method="objectSpanMethod"
          border
          empty-text="该评标项目中，没有有效的供应商投标信息！"
        >
          <el-table-column
            v-for="(item, index) in transposedColumns"
            :key="index"
            :show-overflow-tooltip="true"
          >
            <template slot="header">
              <template v-if="item.required">
                <span class="star">*</span>{{ item.label }}
              </template>
              <template v-else>{{ item.label }}</template>
            </template>
            <template v-if="item.labelChild && item.labelChild.length > 0">
              <el-table-column
                :show-overflow-tooltip="true"
                v-for="(child, indexch) in item.labelChild"
                :key="indexch"
                align="center"
              >
                <template slot="header">
                  <div
                    :title="child.label"
                    class="el-tooltip tooltip-header"
                    :class="{ 'tooltip-header-flow': child.label.length > 15 }"
                  >
                    {{ child.label }}
                  </div>
                </template>
                <template
                  v-if="child.labelChild && child.labelChild.length > 0"
                >
                  <el-table-column
                    :show-overflow-tooltip="true"
                    v-for="(childTwo, indexchTwo) in child.labelChild"
                    :key="indexchTwo"
                    :v-bind="childTwo"
                    align="center"
                  >
                    <template slot="header">
                      <el-button
                        v-if="childTwo.label == '查看投标文件'"
                        size="mini"
                        type="text"
                        @click="viewBidFile(childTwo)"
                        >查看投标文件</el-button
                      >
                      <div
                        v-else
                        :title="childTwo.label"
                        class="el-tooltip tooltip-header"
                        :class="{
                          'tooltip-header-flow': childTwo.label.length > 15
                        }"
                      >
                        {{ childTwo.label }}
                      </div>
                    </template>
                    <template
                      v-if="
                        childTwo.labelChild && childTwo.labelChild.length > 0
                      "
                    >
                      <el-table-column
                        v-for="(childThree, indexch) in childTwo.labelChild"
                        :key="indexch"
                        align="center"
                        v-bind="childThree"
                      >
                        <template slot="header">
                          <div
                            :title="childThree.label"
                            class="el-tooltip tooltip-header"
                            :class="{
                              'tooltip-header-flow':
                                childThree.label.length > 15
                            }"
                          >
                            {{ childThree.label }}
                          </div>
                        </template>
                        <template slot-scope="scope">
                          <el-input
                            v-if="
                              childThree.type == 'input' &&
                                scope.$index != transposedData.length - 1 &&
                                scope.$index != transposedData.length - 2
                            "
                            v-limitdecimal.two
                            v-model="scope.row[scope.column.property]"
                            @change="
                              changeScore(
                                $event,
                                scope.column.property,
                                scope.$index,
                                scope.row
                              )
                            "
                            :min="0"
                            size="mini"
                          ></el-input>
                          <el-input
                            v-else-if="
                              childThree.type == 'input' &&
                                scope.$index == transposedData.length - 2
                            "
                            v-model="scope.row[scope.column.property]"
                            @change="
                              changeDesc(
                                $event,
                                scope.column.property,
                                scope.$index,
                                scope.row
                              )
                            "
                            :min="0"
                            size="mini"
                          ></el-input>
                          <!-- <span
                            class="ellipsis-lines"
                            :title="scope.row[scope.column.property]"
                            v-else-if="childThree.type == 'ai'"
                            @click="toAI(scope.row)"
                            >{{ scope.row[scope.column.property] }}</span
                          > -->
                          <el-button
                            v-else-if="childThree.type == 'ai'"
                            size="mini"
                            type="text"
                            @click="toAI(scope.row, scope.column.property)"
                            >{{
                              scope.row.aiScoreStatus == 2 ||
                              scope.row.aiScoreStatus == 3 ||
                              scope.$index == transposedData.length - 2 ||
                              scope.$index == transposedData.length - 1
                                ? scope.row[scope.column.property]
                                : scope.row.aiScoreStatus == 4
                                ? "解析失败"
                                : "解析中"
                            }}</el-button
                          >

                          <span
                            class="ellipsis-lines"
                            :title="scope.row[scope.column.property]"
                            v-else
                            >{{ scope.row[scope.column.property] }}</span
                          >
                        </template>
                      </el-table-column>
                    </template>
                  </el-table-column>
                </template>
              </el-table-column>
            </template>
            <template slot-scope="scope">
              <el-input
                maxlength="150"
                show-word-limit
                class="input-short word-limit input-width;"
                v-if="item.type == 'input'"
                v-model="scope.row.scoreDesc"
              ></el-input>
              <el-button
                v-else-if="item.type == 'link'"
                size="mini"
                type="text"
                @click="viewBidFile(scope.row)"
                >查看投标文件</el-button
              >
              <span v-else-if="item.money">{{
                scope.row[item.prop]
                  ? new BigNumber(scope.row[item.prop]).toFormat(2)
                  : ""
              }}</span>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="operate">
      <el-button
        type="text"
        icon="icon-ccui-save"
        v-preventReClick
        @click="dealExpertSupScore"
        >保存</el-button
      >
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="供应商投标详细信息"
      width="1200px"
      v-if="dialogVisible"
    >
      <supplierBidDetails
        :supQuoteId="formData.supQuoteId"
        :supPackQuoteId="formData.supPackQuoteId"
        :supCode="formData.supCode"
      ></supplierBidDetails>
      <div slot="footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="dialogVisible = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogScore"
      width="100%"
      height="70vh"
      class="chakanfen"
    >
      <iframe
        :src="scoreUrl"
        frameborder="0"
        height="100%"
        width="100%"
      ></iframe>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="dialogScore = false"
          >关闭</el-button
        >
        <!--<el-button size="mini" type="primary-font-mini" @click="addRoleInfo()"-->
        <!--&gt;提交</el-button-->
        <!--&gt;-->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import BigNumber from "bignumber.js";
import supplierBidDetails from "@/app/sourcingFlow/views/supplierBidDetails.vue";
import breadcrumbSourcing from "@/app/sourcingFlow/components/breadcrumb-sourcing.vue";
import caigoufengxian from "./components/caigoufengxian";
import {
  qryExpertSupPackQuoteToScoreApi,
  dealExpertSupScoreApi,
  qryExpertSupPackQuoteScoreApi,
  listPurchaseSchemePackageApi,
  bidSupPersonnelRelationWarning
} from "@/app/sourcingFlow/api/expertEvaluation.js";

export default {
  name: "addCommercialGrade",
  components: {
    supplierBidDetails,
    breadcrumbSourcing,
    caigoufengxian
  },
  props: {
    type: {
      type: Number,
      default: 0 // type 0:新增 1：编辑
    },
    packId: {
      type: String,
      default: "" // 包件packId
    },
    skillAndCommon: {
      type: Boolean,
      default: false // false:商务评分  true:商务技术评分
    }
  },
  watch: {
    skillAndCommon(val) {
      this.skillAndCommonTemp = val;
    }
  },
  data() {
    return {
      tableTop: 1,
      BigNumber: BigNumber,
      schemeId: JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId,
      skillAndCommonTemp: this.$router.history.current.query.skillAndCommon
        ? this.$router.history.current.query.skillAndCommon
        : this.skillAndCommon,
      breadcrumbData: {
        titname: this.skillAndCommonTemp ? "技术商务评分" : "商务评分"
      },
      tableData: [],
      maxHeight: "",
      headers: [], // 商务表头
      skiiHeaders: [], // 商务技术打分的时候技术表头
      dialogVisible: false,
      dialogScore: false,
      scoreUrl: "",
      formData: {
        supQuoteId: 0, // 供应商报价ID
        supPackQuoteId: "",
        supCode: "" // 供应商编号
      },
      columns: [],
      columnsFree: Object.freeze([
        {
          prop: "id",
          label: "序号",
          fixed: true,
          width: 55
        },
        {
          prop: "supName",
          label: "供应商",
          fixed: true,
          width: 200
        },
        {
          prop: "supTypeNewName",
          label: "供应商类型",
          align: "center",
          width: 100
        },
        {
          prop: "supLevelName",
          label: "供应商等级",
          align: "center",
          width: 100
        },
        {
          prop: "supCategoryName",
          label: "供应商分类",
          align: "center",
          width: 100
        },
        {
          prop: "priceAmount",
          label:
            "投标金额（" + sessionStorage.getItem("moneyTypeName") + "）含税",
          width: 170,
          money: true
        },
        {
          prop: "查看投标文件",
          label: "投标文件",
          width: 150,
          type: "link"
        },
        {
          prop: "sscSkillScoreItemBOS",
          label: "技术",
          labelChild: [],
          required: true,
          align: "center"
        },
        {
          prop: "sscScoreItemBOS",
          label: "商务",
          labelChild: [],
          align: "center",
          required: true
        },
        {
          prop: "supScore",
          label: "汇总得分",
          width: 90
        },
        {
          prop: "scoreDesc",
          label: "打分说明",
          width: 200,
          required: true,
          type: "input"
        }
      ]),
      relationWarningList: [],
      packName: "",
      subPackageFlag: "1" // 是否分包 1分包0不分包
    };
  },
  created() {
    this.maxHeight = window.innerHeight - 320;
  },
  mounted() {
    // if (this.$router.history.current.query.skillAndCommon) {
    //   this.skillAndCommonTemp = this.$router.history.current.query.skillAndCommon;
    // }
    let expertSourceData = JSON.parse(
      sessionStorage.getItem("expertSourceData")
    );
    this.purchaseType = expertSourceData.purchaseType;
    if (this.purchaseType == "50" || this.purchaseType == "53") {
      if (!this.skillAndCommonTemp) {
        this.columns = this.columnsFree.filter(
          n => n.prop !== "sscSkillScoreItemBOS" && n.prop !== "priceAmount"
        );
      } else {
        this.columns = this.columnsFree.filter(n => n.prop !== "priceAmount");
      }
    } else {
      if (!this.skillAndCommonTemp) {
        this.columns = this.columnsFree.filter(
          n => n.prop !== "sscSkillScoreItemBOS"
        );
      } else {
        this.columns = this.columnsFree.map(n => n);
      }
    }

    this.cumputeData();
    this.getPackData();
    this.getSupPersonnelRelationWarning();
  },
  computed: {
    transposedData() {
      let list = [];
      list.push();
      this.columns.forEach(item => {
        if (
          item.prop == "sscSkillScoreItemBOS" ||
          item.prop == "sscScoreItemBOS"
        ) {
          item.labelChild.forEach(aitem => {
            aitem.labelChild.forEach(bitem => {
              bitem.labelChild.forEach(citem => {
                let obj = {};
                obj.pingshenxiangmu = item.label;
                obj.pingshenxize = aitem.label;
                obj.xizequanzhong = bitem.label;
                obj.pingshenbiaozhun = citem.label;
                this.tableData.forEach(o => {
                  obj.originProp = citem.prop;
                  obj["supScore" + o.supCode] = o[citem.prop];
                  obj["aiScore" + o.supCode] = o[citem.prop + "aiScore"];
                  obj.taskId = o.taskId;
                  obj.aiScoreStatus = o.aiScoreStatus;
                  obj.supCode = o.supCode;
                  obj.scoringItemId = o.scoringItemId;
                });
                list.push(obj);
              });
            });
          });
        }
      });
      let explain = {
        pingshenxiangmu: "打分说明"
      };
      let o = { pingshenxiangmu: "汇总得分" };
      this.tableData.forEach(item => {
        o["supScore" + item.supCode] = item.supScore;
        o["aiScore" + item.supCode] = item.aiSumScore
          ? new BigNumber(item.aiSumScore).toFormat(2)
          : item.aiSumScore;
        o.taskId = item.taskId;
        explain["supScore" + item.supCode] = item.scoreDesc;
      });
      list.push(explain);
      list.push(o);
      return list;
    },
    transposedColumns() {
      let arr = [
        {
          prop: "toubiaoxinxi",
          label: "投标信息",
          labelChild: [
            {
              prop: "toubiaojine",
              label:
                "投标金额（" +
                sessionStorage.getItem("moneyTypeName") +
                "）含税",
              align: "center",
              labelChild: [
                {
                  prop: "toubiaojine",
                  label: "投标文件",
                  align: "center",
                  labelChild: [
                    {
                      prop: "pingshenxiangmu",
                      label: "评审项目",
                      align: "center",
                      width: 100
                    },
                    {
                      prop: "pingshenxize",
                      label: "评审细则",
                      align: "center",
                      width: 100
                    },
                    {
                      prop: "xizequanzhong",
                      label: "细则权重",
                      align: "center",
                      width: 100
                    },
                    {
                      prop: "pingshenbiaozhun",
                      label: "评审标准",
                      align: "center",
                      width: 200,
                      minWidth: 200
                    }
                  ]
                }
              ]
            }
          ],
          align: "center"
        }
      ];
      this.tableData.forEach(item => {
        arr.push({
          prop: "gongyingshang" + item.supCode,
          label: item.supName,
          align: "center",
          labelChild: [
            {
              prop: "toubiaojineNum",
              label: item.priceAmount
                ? new BigNumber(item.priceAmount).toFormat(2)
                : "",
              align: "center",
              labelChild: [
                {
                  prop: "chakan",
                  label: "查看投标文件",
                  align: "center",
                  supQuoteId: item.supQuoteId,
                  supPackQuoteId: item.supPackQuoteId,
                  supCode: item.supCode,
                  labelChild: item.taskId
                    ? [
                        {
                          prop: "supScore" + item.supCode,
                          label: "专家打分",
                          align: "center",
                          width: 100,
                          type: "input"
                        },
                        {
                          prop: "aiScore" + item.supCode,
                          label: "AI打分",
                          align: "center",
                          type: "ai",
                          width: 100
                        }
                      ]
                    : [
                        {
                          prop: "supScore" + item.supCode,
                          label: "专家打分",
                          align: "center",
                          width: 100,
                          type: "input"
                        }
                      ]
                }
              ]
            }
          ]
        });
      });
      return arr;
    }
  },
  methods: {
    toAI(row, prop) {
      let baseUrl = "http://47.108.13.132:8102";
      if (window.location.host.indexOf("local") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else if (window.location.host.indexOf("test01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else if (window.location.host.indexOf("uat01") != -1) {
        baseUrl = "https://uat01-aimarket.iccec.cn";
      } else {
        baseUrl = "https://aimarket.iccec.cn";
      }

      if (row.pingshenxiangmu == "汇总得分") {
        this.scoreUrl =
          baseUrl +
          "/front/supplyChain/summaryResults?taskId=" +
          row.taskId +
          "&editable=false&step=1&token=" +
          sessionStorage.getItem("AItoken") +
          "&tech=false&bidSubCompanyCode=" +
          row.supCode +
          "&scoreShowType=ai";
      } else {
        if (row.aiScoreStatus != 2 && row.aiScoreStatus != 3) {
          return;
        }
        this.scoreUrl =
          baseUrl +
          "/front/supplyChain/summaryResults?taskId=" +
          row.taskId +
          "&editable=false&step=1&token=" +
          sessionStorage.getItem("AItoken") +
          "&tech=" +
          (row.pingshenxiangmu == "技术" ? true : false) +
          "&bidSubCompanyCode=" +
          prop.substring(7) +
          "&scoringItemId=" +
          row.originProp.substring(11) +
          "&scoreShowType=ai";
      }
      this.dialogScore = true;
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 只合并第一列
      if (
        columnIndex === 0 &&
        rowIndex != this.transposedData.length - 1 &&
        rowIndex != this.transposedData.length - 2
      ) {
        // 计算相同部门出现的次数
        const rowspan = this.getRowspan(row.pingshenxiangmu, rowIndex);
        if (rowspan.rowspan === 0) {
          return { rowspan: 0, colspan: 0 };
        }
        return {
          rowspan: rowspan.rowspan,
          colspan: 1
        };
      } else if (
        rowIndex == this.transposedData.length - 1 ||
        rowIndex == this.transposedData.length - 2
      ) {
        if (columnIndex === 0) {
          return [1, 4];
        } else if (
          columnIndex === 1 ||
          columnIndex === 2 ||
          columnIndex === 3
        ) {
          return [0, 0];
        }
      }
    },

    getRowspan(department, currentIndex) {
      let rowspan = 1;
      let startIndex = currentIndex;

      // 向前查找相同的部门
      for (let i = currentIndex - 1; i >= 0; i--) {
        if (this.transposedData[i].pingshenxiangmu === department) {
          rowspan++;
          startIndex = i;
        } else {
          break;
        }
      }

      // 向后查找相同的部门
      for (let i = currentIndex + 1; i < this.transposedData.length; i++) {
        if (this.transposedData[i].pingshenxiangmu === department) {
          rowspan++;
        } else {
          break;
        }
      }

      // 如果不是相同单元格组的第一个，返回0
      if (currentIndex !== startIndex) {
        return { rowspan: 0, colspan: 0 };
      }

      return { rowspan, colspan: 1 };
    },
    getSupPersonnelRelationWarning() {
      let param = {
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        step: "6",
        languageFlag: ""
      };
      bidSupPersonnelRelationWarning(param).then(res => {
        if (res.data.code == "0") {
          this.relationWarningList = res.data.data.compareResult;
        }
      });
    },
    cumputeData() {
      if (
        this.$router.history.current.query.type &&
        this.$router.history.current.query.type == "1"
      ) {
        qryExpertSupPackQuoteScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: this.packId
            ? this.packId
            : this.$router.history.current.query.packId,
          joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .joinExpertId,
          scoreItem: this.skillAndCommonTemp ? "" : "1"
        }).then(res => {
          if (res.data.data && res.data.data.length > 0) {
            if (this.skillAndCommonTemp) {
              // this.columns.splice(5, 0, {
              //   prop: "sscSkillScoreItemBOS",
              //   label: "技术",
              //   labelChild: [],
              //   required: true,
              //   align: "center"
              // });
            }
            let labelChild = [];
            let labelSkillChild = [];
            res.data.data.forEach((item, index) => {
              item.supScore = item.supScore
                ? new BigNumber(item.supScore).toFormat(2)
                : item.supScore;
              item.id = index + 1;
              if (!item.supScore) {
                item.supScore = 0;
              }
              item.sscScoreBOS = item.sscSupScoreBOS;
              item.sscScoreBOS.forEach(aItem => {
                aItem.sscScoreItemBOS = aItem.sscSupScoreItemBOS;
                aItem.sscScoreItemBOS.forEach(bItem => {
                  if (!bItem.supScore) {
                    bItem.supScore = 0;
                  }
                  item.scoreRule = bItem.scoreRule;
                  item.scoreWeight = bItem.scoreWeight;
                  item.scoreStandard = bItem.scoreStandard;
                  item.scoringItemId = bItem.scoringItemId;
                  let props =
                    "supScore-" + aItem.scoreItem + "-" + bItem.scoreItemId;
                  item[props] = bItem.supScore
                    ? new BigNumber(bItem.supScore).toFormat(2)
                    : bItem.supScore;
                  item[props + "aiScore"] = bItem.aiScore
                    ? new BigNumber(bItem.aiScore).toFormat(2)
                    : bItem.aiScore;

                  // 细则权重
                  let scoreWeightProps =
                    "maxScoreWeight-" +
                    aItem.scoreItem +
                    "-" +
                    bItem.scoreRule +
                    "-" +
                    bItem.scoreItemId;
                  item[scoreWeightProps] = bItem.scoreWeight;
                  if (this.skillAndCommonTemp) {
                    if (aItem.scoreItem === "0") {
                      if (
                        labelSkillChild.filter(item => {
                          return (
                            item.prop ==
                            "supScore-" +
                              aItem.scoreItem +
                              "-" +
                              bItem.scoreItemId
                          );
                        }).length == 0
                      ) {
                        labelSkillChild.push({
                          prop: props,
                          label: bItem.scoreRule,
                          width: 150,
                          type: "input",
                          labelChild: [
                            {
                              prop: props,
                              label: "细则权重:" + bItem.scoreWeight,
                              width: 150,
                              labelChild: [
                                {
                                  prop: props,
                                  label: bItem.scoreStandard,
                                  width: 150
                                }
                              ]
                              // labelChild: [
                              //   {
                              //     prop: props,
                              //     label: "评分规则内容",
                              //     width: 120
                              //   }
                              // ]
                            }
                          ]
                        });
                      }
                    }
                  }
                  if (aItem.scoreItem === "1") {
                    if (
                      labelChild.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            aItem.scoreItem +
                            "-" +
                            bItem.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelChild.push({
                        prop: props,
                        label: bItem.scoreRule,
                        width: 150,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + bItem.scoreWeight,
                            width: 150,
                            labelChild: [
                              {
                                prop: props,
                                label: bItem.scoreStandard,
                                width: 150
                              }
                            ]
                            // labelChild: [1
                            //   {
                            //     prop: props,
                            //     label: "评分规则内容",
                            //     width: 120
                            //   }
                            // ]
                          }
                        ]
                      });
                    }
                  }
                });
              });
            });
            // if (labelChild.length + labelSkillChild.length < 3) {
            // if (this.skillAndCommonTemp) {
            //   delete this.columns[7].width;
            // } else {
            //   delete this.columns[6].width;
            // }
            // }
            if (this.purchaseType == "50" || this.purchaseType == "53") {
              if (this.skillAndCommonTemp) {
                this.columns[7].labelChild = labelChild;
                this.columns[6].labelChild = labelSkillChild;
              } else {
                this.columns[6].labelChild = labelChild;
              }
            } else {
              if (this.skillAndCommonTemp) {
                this.columns[8].labelChild = labelChild;
                this.columns[7].labelChild = labelSkillChild;
              } else {
                this.columns[7].labelChild = labelChild;
              }
            }
            this.tableData = res.data.data;
            console.log(this.tableData);
            this.$nextTick(() => {
              // this.$refs.table.doLayout();
            });
          }
        });
      } else {
        qryExpertSupPackQuoteToScoreApi({
          schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
            .schemeId,
          packId: this.packId
            ? this.packId
            : this.$router.history.current.query.packId,
          scoreItem: this.skillAndCommonTemp ? "" : "1"
        }).then(res => {
          if (res.data.data && res.data.data.length > 0) {
            // if (this.skillAndCommonTemp) {
            // this.columns.splice(5, 0, {
            //   prop: "sscSkillScoreItemBOS",
            //   label: "技术",
            //   labelChild: [],
            //   required: true,
            //   align: "center"
            // });
            // }
            let labelChild = [];
            let labelSkillChild = [];
            res.data.data.forEach((item, index) => {
              item.supScore = item.supScore
                ? new BigNumber(item.supScore).toFormat(2)
                : item.supScore;
              item.id = index + 1;
              if (!item.supScore) {
                item.supScore = 0;
              }
              item.sscScoreBOS.forEach(sscScoreBOItem => {
                sscScoreBOItem.sscScoreItemBOS.forEach(sscScoreItemBO => {
                  item.scoringItemId = sscScoreItemBO.scoringItemId;
                  if (!sscScoreItemBO.supScore) {
                    sscScoreItemBO.supScore = "";
                  }
                  item.scoreRule = sscScoreItemBO.scoreRule;
                  item.scoreWeight = sscScoreItemBO.scoreWeight;
                  item.scoreStandard = sscScoreItemBO.scoreStandard;
                  let props =
                    "supScore-" +
                    sscScoreBOItem.scoreItem +
                    "-" +
                    sscScoreItemBO.scoreItemId;
                  item[props + "aiScore"] = sscScoreItemBO.aiScore
                    ? new BigNumber(sscScoreItemBO.aiScore).toFormat(2)
                    : sscScoreItemBO.aiScore;

                  item[props] = sscScoreItemBO.supScore
                    ? new BigNumber(sscScoreItemBO.supScore).toFormat(2)
                    : sscScoreItemBO.supScore;
                  // 细则权重
                  let scoreWeightProps =
                    "maxScoreWeight-" +
                    sscScoreBOItem.scoreItem +
                    "-" +
                    sscScoreItemBO.scoreRule +
                    "-" +
                    sscScoreItemBO.scoreItemId;
                  item[scoreWeightProps] = sscScoreItemBO.scoreWeight;
                  if (this.skillAndCommonTemp) {
                    if (sscScoreBOItem.scoreItem === "0") {
                      if (
                        labelSkillChild.filter(item => {
                          return (
                            item.prop ==
                            "supScore-" +
                              sscScoreBOItem.scoreItem +
                              "-" +
                              sscScoreItemBO.scoreItemId
                          );
                        }).length == 0
                      ) {
                        labelSkillChild.push({
                          prop: props,
                          label: sscScoreItemBO.scoreRule,
                          width: 150,
                          type: "input",
                          labelChild: [
                            {
                              prop: props,
                              label: "细则权重:" + sscScoreItemBO.scoreWeight,
                              width: 150,
                              labelChild: [
                                {
                                  prop: props,
                                  label: sscScoreItemBO.scoreStandard,
                                  width: 150
                                }
                              ]
                              // labelChild: [
                              //   {
                              //     prop: props,
                              //     label: "评分规则内容",
                              //     width: 120
                              //   }
                              // ]
                            }
                          ]
                        });
                      }
                    }
                  }
                  if (sscScoreBOItem.scoreItem === "1") {
                    if (
                      labelChild.filter(item => {
                        return (
                          item.prop ==
                          "supScore-" +
                            sscScoreBOItem.scoreItem +
                            "-" +
                            sscScoreItemBO.scoreItemId
                        );
                      }).length == 0
                    ) {
                      labelChild.push({
                        prop: props,
                        label: sscScoreItemBO.scoreRule,
                        width: 150,
                        type: "input",
                        labelChild: [
                          {
                            prop: props,
                            label: "细则权重:" + sscScoreItemBO.scoreWeight,
                            width: 150,
                            labelChild: [
                              {
                                prop: props,
                                label: sscScoreItemBO.scoreStandard,
                                width: 150
                              }
                            ]
                            // labelChild: [
                            //   {
                            //     prop: props,
                            //     label: "评分规则内容",
                            //     width: 120
                            //   }
                            // ]
                          }
                        ]
                      });
                    }
                  }
                });
              });
            });
            if (this.purchaseType == "50" || this.purchaseType == "53") {
              if (this.skillAndCommonTemp) {
                this.columns[7].labelChild = labelChild;
                this.columns[6].labelChild = labelSkillChild;
              } else {
                this.columns[6].labelChild = labelChild;
              }
            } else {
              if (this.skillAndCommonTemp) {
                this.columns[8].labelChild = labelChild;
                this.columns[7].labelChild = labelSkillChild;
              } else {
                this.columns[7].labelChild = labelChild;
              }
            }
            this.tableData = res.data.data;
            console.log(this.tableData);
            this.$nextTick(() => {
              // this.$refs.table.doLayout();
            });
          }
        });
      }
    },
    getPackData() {
      listPurchaseSchemePackageApi({
        pageNo: 1,
        pageSize: 100,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag = res.data.data.subPackageFlag;
        let packId = this.packId
          ? this.packId
          : this.$router.history.current.query.packId;
        res.data.data.purchaseSchemePackageList.forEach(item => {
          if (item.packId == packId) {
            this.packName = item.packName;
          }
        });
      });
    },
    viewBidFile(row) {
      this.formData.supQuoteId = row.supQuoteId;
      this.formData.supPackQuoteId = row.supPackQuoteId;
      this.formData.supCode = row.supCode;
      this.dialogVisible = true;
    },
    // 改变分数计算汇总得分
    changeScore(value, prop, index, row) {
      this.tableData.forEach((it, i) => {
        if (it.supCode == prop.substring(8)) {
          it[row.originProp] = value;
          prop = row.originProp;
          index = i;
        }
      });
      let total = 0;
      let flag = true;
      let message = "";
      try {
        for (let key in this.tableData[index]) {
          if (key.includes("supScore-") && !key.includes("aiScore")) {
            // 不能大于权重大小
            for (let keyWeight in this.tableData[index]) {
              if (keyWeight.includes("maxScoreWeight-")) {
                let scoreItem = key.substring(9, 10);
                let scoreWeightItem = keyWeight.substring(15, 16);
                let scoreItemId = key.substring(11);
                let scoreWeightItemId = keyWeight.substring(
                  keyWeight.lastIndexOf("-") + 1
                );
                let scoreRule = keyWeight.substring(
                  17,
                  keyWeight.lastIndexOf("-")
                );
                if (
                  scoreItem === scoreWeightItem &&
                  scoreItemId === scoreWeightItemId
                ) {
                  if (
                    Number(this.tableData[index][key]) >
                    Number(this.tableData[index][keyWeight])
                  ) {
                    flag = false;
                    this.tableData[index][prop] = 0;
                    message =
                      this.tableData[index].supName +
                      "的" +
                      scoreRule +
                      "的得分不允许大于细则权重" +
                      this.tableData[index][keyWeight] +
                      "分，谢谢您的配合！";
                    throw Error();
                  }
                }
              }
            }
            //total += Number(this.tableData[index][key]);
            total = window.$computeUtil.getPlus(
              total,
              this.tableData[index][key] || "0"
            );
          }
        }
      } catch (e) {
        console.log(e);
      }
      if (total) {
        //total = Number(total).toFixed(2);
        total = new BigNumber(total).toFormat(2);
      }
      if (flag) {
        this.$set(this.tableData[index], "supScore", total);
      } else {
        this.$message({
          message: message,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    changeDesc(value, prop, index, row) {
      this.tableData.forEach((it, i) => {
        if (it.supCode == prop.substring(8)) {
          it[row.originProp] = value;
          prop = row.originProp ? row.originProp : prop;
          index = i;
        }
      });
      this.$set(this.tableData[index], "scoreDesc", value);
    },
    // 保存
    dealExpertSupScore() {
      if (this.tableData.length === 0) {
        this.$message({
          message: `供应商已全部淘汰，请联系采购承办人进行流标操作`,
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      } else {
        let sscExpertSupScoreBOS = [];
        let flag = true;
        let message = "";
        if (this.skillAndCommonTemp) {
          try {
            this.tableData.forEach((item, index) => {
              let tempSscExpertSupScoreBOS = []; // 技术商务评分的时候临时存的数据
              let scoreItemIdArr = [];
              if (!item.scoreDesc) {
                flag = false;
                message = item.supName + "的打分说明不能为空";
                throw Error();
              }
              for (let key in item) {
                if (!key.includes("aiScore") && key.includes("supScore-")) {
                  // 不能大于权重大小
                  for (let keyWeight in item) {
                    if (keyWeight.includes("maxScoreWeight-")) {
                      let scoreItem = key.substring(9, 10);
                      let scoreWeightItem = keyWeight.substring(15, 16);
                      let scoreItemId = key.substring(11);
                      let scoreWeightItemId = keyWeight.substring(
                        keyWeight.lastIndexOf("-") + 1
                      );
                      let scoreRule = keyWeight.substring(
                        17,
                        keyWeight.lastIndexOf("-")
                      );
                      if (
                        scoreItem === scoreWeightItem &&
                        scoreItemId === scoreWeightItemId
                      ) {
                        if (
                          Number(this.tableData[index][key]) >
                          Number(this.tableData[index][keyWeight])
                        ) {
                          flag = false;
                          message =
                            this.tableData[index].supName +
                            "的" +
                            scoreRule +
                            "的得分不允许大于细则权重" +
                            this.tableData[index][keyWeight] +
                            "分，谢谢您的配合！";
                          throw Error();
                        }
                      }
                    }
                  }
                  // 得分不能为空
                  if (
                    !Number(this.tableData[index][key]) &&
                    this.tableData[index][key] !== 0 &&
                    this.tableData[index][key] !== "0.00" &&
                    this.tableData[index][key] !== "0"
                  ) {
                    flag = false;
                    message = this.tableData[index].supName + "的评分不能为空";
                    throw Error();
                  }
                  let obj = {};
                  obj.supCode = item.supCode;
                  obj.supName = item.supName;
                  obj.supScore = item.supScore;
                  obj.scoreDesc = item.scoreDesc;
                  let sscSupScoreItemBOS = [];
                  obj.scoreItem = key.substring(9, 10);
                  if (!scoreItemIdArr.includes(key)) {
                    scoreItemIdArr.push(key);
                    if (!key.substring(11).includes("aiScore")) {
                      let sscScoreObj = {};
                      sscScoreObj.scoreItemId = key.substring(11);
                      sscScoreObj.supScore = this.tableData[index][key];
                      sscSupScoreItemBOS.push(sscScoreObj);
                    }
                  }
                  obj.sscSupScoreItemBOS = sscSupScoreItemBOS;
                  tempSscExpertSupScoreBOS.push(obj);
                }
                if (
                  !item.scoreDesc ||
                  (key == "scoreDesc" && !this.tableData[index][key])
                ) {
                  flag = false;
                  message =
                    this.tableData[index].supName + "的打分说明不能为空";
                  throw Error();
                }
              }
              let skillSscSupScoreItemBOS = []; // 技术
              let commonSscSupScoreItemBOS = []; // 商务
              tempSscExpertSupScoreBOS.forEach(temp => {
                if (temp.scoreItem == "0") {
                  // 技术
                  temp.sscSupScoreItemBOS.forEach(sscItem => {
                    skillSscSupScoreItemBOS.push(sscItem);
                  });
                } else {
                  // 商务
                  temp.sscSupScoreItemBOS.forEach(sscItem => {
                    commonSscSupScoreItemBOS.push(sscItem);
                  });
                }
              });
              if (skillSscSupScoreItemBOS.length) {
                sscExpertSupScoreBOS.push({
                  scoreItem: "0",
                  supCode: item.supCode,
                  supName: item.supName,
                  supScore: item.supScore,
                  scoreDesc: item.scoreDesc,
                  sscSupScoreItemBOS: skillSscSupScoreItemBOS
                });
              }
              if (commonSscSupScoreItemBOS.length) {
                sscExpertSupScoreBOS.push({
                  scoreItem: "1",
                  supCode: item.supCode,
                  supName: item.supName,
                  supScore: item.supScore,
                  scoreDesc: item.scoreDesc,
                  sscSupScoreItemBOS: commonSscSupScoreItemBOS
                });
              }
            });
          } catch (e) {
            console.log(e);
          }
        } else {
          try {
            this.tableData.forEach((item, index) => {
              let scoreItemIdArr = [];
              let obj = {};
              obj.supCode = item.supCode;
              obj.supName = item.supName;
              obj.supScore = item.supScore;
              obj.scoreDesc = item.scoreDesc;
              obj.scoreItem = "1";
              let sscSupScoreItemBOS = [];
              if (!item.scoreDesc) {
                flag = false;
                message = item.supName + "的打分说明不能为空";
                throw Error();
              }

              for (let key in item) {
                if (key.includes("supScore-") && !key.includes("aiScore")) {
                  // 不能大于权重大小
                  for (let keyWeight in item) {
                    if (keyWeight.includes("maxScoreWeight-")) {
                      let scoreItem = key.substring(9, 10);
                      let scoreWeightItem = keyWeight.substring(15, 16);
                      let scoreItemId = key.substring(11);
                      let scoreWeightItemId = keyWeight.substring(
                        keyWeight.lastIndexOf("-") + 1
                      );
                      let scoreRule = keyWeight.substring(
                        17,
                        keyWeight.lastIndexOf("-")
                      );
                      if (
                        scoreItem === scoreWeightItem &&
                        scoreItemId === scoreWeightItemId
                      ) {
                        if (
                          Number(this.tableData[index][key]) >
                          Number(this.tableData[index][keyWeight])
                        ) {
                          flag = false;
                          message =
                            item.supName +
                            "的" +
                            scoreRule +
                            "的得分不允许大于细则权重" +
                            this.tableData[index][keyWeight] +
                            "分，谢谢您的配合！";
                          throw Error();
                        }
                      }
                    }
                  }

                  if (
                    !Number(this.tableData[index][key]) &&
                    this.tableData[index][key] !== 0 &&
                    this.tableData[index][key] !== "0.00" &&
                    this.tableData[index][key] !== "0"
                  ) {
                    flag = false;
                    message = item.supName + "的评分不能为空";
                    throw Error();
                  }
                  if (!scoreItemIdArr.includes(key)) {
                    scoreItemIdArr.push(key);
                    if (!key.substring(11).includes("aiScore")) {
                      let sscScoreObj = {};
                      sscScoreObj.scoreItemId = key.substring(11);
                      sscScoreObj.supScore = this.tableData[index][key];
                      sscSupScoreItemBOS.push(sscScoreObj);
                    }
                  }
                }
                if (
                  !item.scoreDesc ||
                  (key == "scoreDesc" && !this.tableData[index][key])
                ) {
                  flag = false;
                  message = item.supName + "的打分说明不能为空";
                  throw Error();
                }
              }
              obj.sscSupScoreItemBOS = sscSupScoreItemBOS;
              sscExpertSupScoreBOS.push(obj);
            });
          } catch (e) {
            console.log(e);
          }
        }
        if (flag) {
          let param = {
            schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .schemeId,
            packId: this.packId
              ? this.packId
              : this.$router.history.current.query.packId,
            packName: this.packName,
            joinExpertId: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .joinExpertId,
            expertName: JSON.parse(sessionStorage.getItem("expertSourceData"))
              .expertName,
            purStep: this.$router.history.current.query.menuKey,
            scoreType: this.skillAndCommonTemp ? "2" : "1",
            sscExpertSupScoreBOS: sscExpertSupScoreBOS
          };
          dealExpertSupScoreApi(param).then(res => {
            this.$message({
              message: "评分表保存成功",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            this.$router.push({
              name: "commercialGradeListWZ",
              query: {
                backPageSkillAndCommon: this.skillAndCommonTemp ? "1" : "2", // 商务技术：1 商务：2
                a: this.$router.history.current.query.a,
                menuKey: this.$router.history.current.query.menuKey,
                evaPurStep: this.$router.history.current.query.evaPurStep,
                active: this.$route.query.active
              }
            });
          });
        } else {
          this.$message({
            message: message,
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
  color: red;
  padding: 20px 0 0 20px;
}
.star {
  color: #ff1818;
}
.wd2 {
  width: 20px;
}
.wd6 {
  width: 60px;
}
.wd10 {
  width: 100px;
}
.wd20 {
  width: 200px;
}
/deep/ .el-table tr {
  td,
  th {
    height: 36px !important;
    line-height: 36px !important;
    padding: 0;
    //padding: 5px 10px !important;
    //box-sizing: border-box !important;
    //text-overflow: ellipsis !important;
    //white-space: nowrap;
  }
}
/deep/.el-dialog {
  overflow: hidden;
  margin-top: 0px;
  width: calc(100% - 240px) !important;
  left: 100px !important;
  top: 45px !important;
  .el-dialog__body {
    max-height: calc(100vh - 130px - 94px - 20px) !important;
    height: calc(100vh - 130px - 94px - 20px) !important;
  }
}
/deep/.chakanfen {
  .el-dialog {
    width: calc(100%) !important;
    left: 0px !important;
  }
}
.priamryColor {
  color: #0089ef;
  cursor: pointer;
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
/deep/ .el-table th > .cell {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  text-align: center;
}
.tooltip-header {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  margin: 10px 0;
  line-height: 20px;
}
</style>
<style lang="scss">
.iframeMain-box .dic-ccui-app-main {
  padding-bottom: 1px !important;
}
.iframeBody .iframeMain .iframeMain-box .ccui-app-box-iframe-operate-container {
  padding-bottom: 76px;
}
.ellipsis-lines {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 限制行数为3 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 3px;
}
</style>
